import React from "react";
import styled from "styled-components";

import colors from "styles/colors";
import text from "styles/text";
import media from "styles/media";

import { ReactComponent as CheckSVG } from "assets/images/icons/check.svg";

type Props = {
  completed?: boolean;
  number: string;
  title: string;
};

const RoadmapCard: React.FC<Props> = ({ completed, number, title }) => {
  return (
    <Wrapper completed={completed}>
      <Top>
        <Number>{number}</Number>
        {completed && <Check />}
      </Top>
      <Title completed={completed}>{title}</Title>
    </Wrapper>
  );
};

export default RoadmapCard;

const Wrapper = styled.div<{ completed?: boolean }>`
  background: ${(props) => (props.completed ? colors.pureWhite : colors.black100)};
  border-radius: 1px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 37.5vw;
  height: 20.83vw;
  padding-top: 1.39vw;
  padding-right: 2.78vw;
  padding-bottom: 2.78vw;
  padding-left: 2.78vw;

  ${media.tablet} {
    height: 29.3vw;
    width: 52.73vw;
    padding-top: 1.95vw;
    padding-left: 3.91vw;
    padding-right: 3.91vw;
    padding-bottom: 3.91vw;
  }

  ${media.mobile} {
    padding: 5.333vw 8vw 0 4vw;
    width: 86.93vw;
    height: 66.667vw;
  }
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 1.39vw;

  ${media.tablet} {
    margin-bottom: 1.95vw;
  }

  ${media.mobile} {
    margin-bottom: 5.333vw;
  }
`;

const Number = styled.div`
  ${text.desktop.accent1}
  background: ${colors.horzGradient};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  ${media.tablet} {
    ${text.tablet.accent1}
  }

  ${media.mobile} {
    ${text.mobile.accent2}
  }
`;

const Check = styled(CheckSVG)`
  path {
    stroke: ${colors.pureBlack};
  }

  width: 1.74vw;
  height: 1.74vw;

  ${media.tablet} {
    width: 2.44vw;
    height: 2.44vw;
  }
  ${media.mobile} {
    width: 5.33vw;
    height: 5.33vw;
  }
`;

const Title = styled.h5<{ completed?: boolean }>`
  ${text.desktop.h5}
  color: ${(props) => (props.completed ? colors.pureBlack : colors.pureWhite)};
  width: 100%;
  text-transform: uppercase;
  letter-spacing: -0.05em;

  ${media.tablet} {
    ${text.tablet.h5}
  }
  ${media.mobile} {
    ${text.mobile.h6}
  }
`;
